import { render } from "./PrivateModalPage.vue?vue&type=template&id=f68c87a4&scoped=true"
import script from "./PrivateModalPage.vue?vue&type=script&lang=js"
export * from "./PrivateModalPage.vue?vue&type=script&lang=js"

import "./PrivateModalPage.vue?vue&type=style&index=0&id=f68c87a4&lang=scss&scoped=true"

import exportComponent from "/home/olt/CloudRaiseWebSite/vue/client/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f68c87a4"]])

export default __exports__